import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var __jsx = React.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false,
      eventId: ''
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // use console.log to keep the usage of the parameters
      console.log(error);
      console.log(errorInfo);
      var eventId = ''; // TODO : use NewRelic Browser for eventId generation

      this.setState({
        eventId: eventId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hasError = _this$state.hasError,
          eventId = _this$state.eventId; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

      var _this$props = this.props,
          FallbackComponent = _this$props.FallbackComponent,
          children = _this$props.children;
      return hasError ? __jsx(FallbackComponent, {
        eventId: eventId
      }) : children;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // If there was an error generated within getInitialProps, and we haven't
      // yet seen an error, we add it to this.state here
      return {
        hasError: props.hasError || state.hasError || false,
        eventId: props.eventId || state.eventId || ''
      };
    }
  }, {
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true,
        eventId: ''
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

export default ErrorBoundary;